import ScrollMagic from 'scrollmagic';
import "scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators";

export default () => {  
    let controller = new ScrollMagic.Controller();
    // let projectHeaderTag = document.getElementById("projectHeaderTag");
    let projectHeaderBar = document.getElementById("projectHeaderBar");
    let contentsButton = document.getElementById('contentsButton');
    let sidebar = document.getElementById('entrySidebar');
    let footer = document.getElementById('footer');
    let footerHeight = footer.clientHeight;
    new ScrollMagic.Scene({
        duration: "50%",
        triggerHook: 0,
        offset: "-50px"
                })
                .on("enter", function (i) { 
                    projectHeaderBar.classList.add("-translate-y-full");
                    // projectHeaderTag.classList.remove("-translate-y-32");
                    // contentsButton.classList.add('opacity-0');
                    // entrySidebar.classList.add("opacity-0");
                })
                .on("leave", function (i) { 
                    projectHeaderBar.classList.remove("-translate-y-full"); 
                    // projectHeaderTag.classList.add("-translate-y-32");
                    // contentsButton.classList.remove('opacity-0');
                    // entrySidebar.classList.remove("opacity-0");
                })
                // .addIndicators({name: "TOP" })
                .addTo(controller)

    new ScrollMagic.Scene({
        duration: footerHeight + 'px',
        triggerElement: '#footer',
        offset: '-90px',
        triggerHook: 0.8,
                })
                .on("enter", function (i) { 
                    // projectHeaderTag.classList.remove("-translate-y-32");
                    // contentsButton.classList.add('opacity-0');
                    // entrySidebar.classList.add("opacity-0");
                })
                .on("leave", function (i) { 
                    // projectHeaderTag.classList.add("-translate-y-32");
                    // contentsButton.classList.remove('opacity-0');
                    // entrySidebar.classList.remove("opacity-0");
                })
                .on("end", function (i) { 
                    // projectHeaderTag.classList.remove("-translate-y-32");
                    // contentsButton.classList.add('opacity-0');
                    // entrySidebar.classList.add("opacity-0");
                })
                // .addIndicators({name: "TOP" })
                .addTo(controller)


    let chapters = document.getElementsByClassName("subtitleTrigger");
    if (chapters.length > 0) {
        let contentsHeader = document.getElementById("contentHeader");
        let y;
        for (y=0; y < chapters.length; y++) {
            let chapterTitle = chapters[y].getAttribute("data-chapterTitle");
            let chapterId = chapters[y].getAttribute('data-link');
            console.log(chapterId);
            new ScrollMagic.Scene({
                triggerElement: chapters[y],// y value not modified, so we can use element as trigger as well
                duration: "10"
                        })
                        .on("enter", function (i) {contentsHeader.innerHTML = chapterTitle;
                            // window.location.hash = chapterId;
                            // setTimeout(function() {history.pushState(null, null, '#' + chapterId)}, 500);
                        })
                        // .addIndicators({name: chapterTitle })
                        .addTo(controller)
        };
    };

    let mainContent = document.getElementsByClassName('entryMainContent');
    if (mainContent.length > 0) {
        let mc;
        for (mc = 0; mc < mainContent.length; mc ++) {

                let textHighlights = mainContent[mc].querySelectorAll('mark');
                if (textHighlights.length > 0) {
                    let th;
                    for (th = 0; th < textHighlights.length; th++) {
                        let highElem = textHighlights[th];
                        new ScrollMagic.Scene({
                            triggerElement: highElem,// y value not modified, so we can use element as trigger as well
                            triggerHook: 0.7,
                            duration: "1000px"
                                    })
                                    .on("enter", function (e) {
                                        console.log(highElem);
                                        highElem.classList.add('highlightActive');
                                        // window.location.hash = chapterId;
                                        // setTimeout(function() {history.pushState(null, null, '#' + chapterId)}, 500);
                                    })
                                    // .addIndicators({name: 'Highlight' })
                                    .addTo(controller)
                    }
                }

        };
    };
}